export class SubmissionDomain {

  constructor(
    public name: string,
    public description: string,
  ) {  }

}
